import { FlashMessageGenerateTokenDto } from "../../dto/flashmessagegenereratetoken/flashmessagegeneratetoken";
import { APIRequest, APIRequestDtoImpl } from "../apiRequest";


export interface FlashMessageGenerateTokenRequest extends APIRequest
{
    getFlashMessageGenerateTokenRequest(): FlashMessageGenerateTokenDto;
}

export class FlashMessageGenerateTokenRequestImpl extends APIRequestDtoImpl implements FlashMessageGenerateTokenRequest
{
    constructor(private getFlashMessageGenerateTokenData: FlashMessageGenerateTokenDto)
    {
        super();
    }

    getFlashMessageGenerateTokenRequest(): FlashMessageGenerateTokenDto
    {
        return this.getFlashMessageGenerateTokenData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenrequest.tsx